import axios, { AxiosInstance } from 'axios';
import { Endpoints } from '../endpoints';

export interface GetParticipantInfoResponse {
  name: string;
  dateOfBirth: string;
  street: string;
  city: string;
  state: string;
  zip: string;
}

export const getParticipantInfo = async (instance: AxiosInstance = axios) => {
  return instance.get<GetParticipantInfoResponse>(Endpoints.Participant.PARTICIPANT_INFO);
};

export interface UpdateParticipantInfoRequest {
  street: string;
  city: string;
  stateId: string;
  zip: string;
}

/**
 * Update the participants address.
 * @param req
 * @param instance - Axios instance that will be used to query the API.
 * @returns
 */
export const updateParticipantInfo = async (
  req: UpdateParticipantInfoRequest,
  instance: AxiosInstance = axios,
) => instance.put(Endpoints.Participant.UPDATE_INFO, req);
